<template>
  <el-affix :offset="0" position="top">
    <div class="head">
      <el-row>
        <el-col :lg="3" :md="3" :sm="3" :xs="4">
          <a href="https://www.wendu.com/" class="head-logo" target="_blank"><img
              src="../../assets/images/icon/logo.png" alt=""></a>
        </el-col>
        <el-col :lg="17" :md="17" :sm="17" :xs="14">
          <div class="head-nav">
            <span @click="togoLocal('/','module1')">关于文都</span>
            <span class="hidden-sm-and-down" @click="togoLocal('/','module2')">企业文化</span>
            <span class="hidden-sm-and-down" @click="togoLocal('/','module3')">项目介绍</span>
            <span class="hidden-sm-and-down" @click="togoLocal('/','module4')">文都风采</span>
            <span class="hidden-sm-and-down" @click="togoLocal('/','module5')">合作流程</span>
            <span class="hidden-sm-and-down" @click="togoLocal('/','module6')">总部支持</span>
            <router-link :to="{path:'/apply'}" target="_blank">申请表单</router-link>
            <router-link :to="{path:'/contactUs'}" target="_blank">联系我们</router-link>
            <a class="hidden-sm-and-down" href="https://www.wendu.com/" target="_blank">文都网</a>
          </div>
        </el-col>
        <el-col :lg="4" :md="4" :sm="4" :xs="6">
          <div class="head-tel"><span>15600128367</span></div>
        </el-col>
      </el-row>
    </div>
  </el-affix>
</template>

<script >
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "head",
  setup() {
    const router = useRouter();
    const currentPath=router.currentRoute.value.fullPath
    const togoLocal = (page, domId) => {
        // 已经在当前页面不跳转
        if(page==currentPath){ 
            document.getElementById(domId).scrollIntoView(true)
        }else{
            let routerUrl=router.resolve({
                path:page,params:{module:domId}
            })
            window.open(routerUrl.href,'_blank')
            localStorage.setItem('moduleId',domId)
            
        }
    };
    
    return { togoLocal };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.head {
  height: 64px;
  padding: 0 32px;
  background: #fff;
  min-width:1200px;
  .head-logo {
    img {
      width: 120px;
      //   height: 64px;
      height: auto;
      max-width: 100%;
    }
  }
  .head-nav {
    height: 64px;
    line-height: 64px;
    color: #1b1d1f;
    font-size: 16px;
    font-weight: bold;
    span,
    a {
      float: left;
      padding: 0 12px;
      color: #1b1d1f;
      &:hover {
        color: #0099ff;
      }
    }
  }
  .head-tel {
    line-height: 64px;
    font-size: 20px;
    color: #1b1d1f;
    font-weight: bold;
    overflow: hidden;
    span {
      float: right;
      height: 64px;
      padding-left: 32px;
      background: url(../../assets/images/icon/ic_menuphone.png) left center
        no-repeat;
      background-size: 24px 24px;
    }
  }
}
</style>
